import React, { useState } from 'react';
import {
  Box, Card, CardContent, TextField, Button,
  Typography, Alert, CircularProgress
} from '@mui/material';
import { useAuth } from './AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      await login(email, senha);
    } catch {
      setErro('Email ou senha incorretos. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a1525 0%, #132240 50%, #0d2340 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2
    }}>
      <Card sx={{
        width: '100%',
        maxWidth: 420,
        borderRadius: 3,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <CardContent sx={{ p: 5 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Box sx={{
              width: 96, height: 96, borderRadius: 3,
              background: 'radial-gradient(circle at 30% 30%, #1a3260, #0a1525)',
              border: '1.5px solid rgba(0,184,204,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 0 24px rgba(0,184,204,0.18), inset 0 1px 0 rgba(255,255,255,0.08)',
              margin: '0 auto 16px',
            }}>
              <img src="/logo.png" alt="Tovis" style={{ width: 70, height: 70, objectFit: 'contain' }} />
            </Box>
            <Typography variant="h3" sx={{
              fontWeight: 800,
              color: '#1B3A6B',
              letterSpacing: '-1px',
              fontFamily: "'Inter', sans-serif",
            }}>
              TOVIS
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151', mt: 0.5, fontFamily: "'Inter', sans-serif" }}>
              Sistema de Gestão de Endemias
            </Typography>
          </Box>

          {erro && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
              {erro}
            </Alert>
          )}

          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ mb: 2 }}
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Senha"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              sx={{ mb: 3 }}
              variant="outlined"
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              disabled={carregando}
              sx={{
                py: 1.5,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #1B3A6B, #2D5A9E)',
                fontWeight: 700,
                fontSize: '1rem',
                '&:hover': {
                  background: 'linear-gradient(135deg, #152d52, #234a80)',
                }
              }}
            >
              {carregando ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
            </Button>
          </form>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #F3F4F6', textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: '#9CA3AF', display: 'block' }}>
              © 2026 Tovis — Sistema de Gestão de Endemias
            </Typography>
            <Typography variant="caption" sx={{ color: '#9CA3AF', display: 'block', mt: 0.5 }}>
              Desenvolvido e mantido por <strong style={{ color: '#6B7280' }}>Walber Reis</strong>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
